import { Button } from '@skin-seoul/design-system';
import { useState } from 'react';
import { TrackOrderModal } from '../TrackOrderModal';

export const DeliveryTrackingBanner = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleTrackDelivery = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="w-full bg-neutral-75 flex items-center justify-center">
      <div className="max-w-[1280px] w-full px-4 desktop:px-16 py-6 flex items-center justify-center gap-3 tablet:gap-4 flex-col">
        <p className="text-neutral-700 text-heading-h6-mobile tablet:text-heading-h6 font-medium text-center">
          Want to track your order as a guest?
        </p>
        <Button
          variant="dark"
          className="rounded-[8px] font-medium px-4 py-2 shrink-0"
          onClick={handleTrackDelivery}
          type="button"
        >
          Track Delivery
        </Button>
        <TrackOrderModal isOpen={isModalOpen} onClose={handleModalClose} />
      </div>
    </div>
  );
};
